"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
// prettier-ignore
var NON_DROPPING_PARTICLES = new Set([
    "'s", "'s-", "'t", 'a', "aan 't", 'aan de', 'aan den', 'aan der', 'aan het', 'aan t', 'aan',
    'am de', 'am', 'auf ter', 'ben', "bij 't", 'bij de', 'bij den', 'bij het', 'bij t', 'bij',
    'bin', 'boven d', "boven d'", 'd', 'dal', "dal'", "dall'", 'dalla', 'de die le', 'de die',
    'de l', "de l'", 'de la', 'de las', 'de le', 'de van der', 'deca', 'dela', 'die le', 'do',
    'don', 'het', 'i', 'il', 'im', "in 't", 'in de', 'in den', 'in het', 'in t', 'in', 'l', "l'",
    'la', 'las', 'le', 'los', 'lou', 'of', "onder 't", 'onder de', 'onder den', 'onder het',
    'onder t', 'onder', "op 't", 'op den', 'op der', 'op gen', 'op het', 'op t', 'op ten', 'op',
    "over 't", 'over de', 'over den', 'over het', 'over t', 'over', 's', "s'", 't', 'te', 'ten',
    'ter', 'tho', 'thoe', 'thor', 'to', 'toe', 'tot', "uijt 't", 'uijt de', 'uijt den', 'uijt te de',
    'uijt ten', 'uijt', "uit 't", 'uit de', 'uit den', 'uit het', 'uit t', 'uit te de', 'uit ten',
    'uit', 'unter', 'v', 'v.', 'v.d.', "van 't", 'van de l', "van de l'", 'van de', 'van de',
    'van den', 'van der', 'van gen', 'van het', 'van la', 'van t', 'van ter', 'van van de', 'vander',
    'vd', 'ver', "von 't", 'von t', "voor 't", 'voor de', 'voor den', "voor in 't", 'voor in t', 'voor',
]);
function parseNameParticles(input) {
    return NON_DROPPING_PARTICLES.has(input.toLowerCase())
        ? { 'non-dropping-particle': input }
        : { 'dropping-particle': input };
}
exports.parseNameParticles = parseNameParticles;
function default_1(name) {
    var _a, _b, _c;
    var FIRST_VON_LAST = /([A-Z][a-zA-Z-]+ )?([a-z][a-zA-Z-]+ .+? [a-z][a-zA-Z-]+ )?([A-Z].+)/;
    var VON_LAST_FIRST = /(.+ [a-z][a-zA-Z-]+ )?(.+), (.+)/;
    var VON_LAST_JR_FIRST = /(.+ [a-z][a-zA-Z-]+ )?(.+), (.+), (.+)/;
    var first = '';
    var von = '';
    var last = '';
    var suffix = '';
    var literal = '';
    var match;
    switch (name.split(',').length) {
        case 1:
            match = name.match(FIRST_VON_LAST);
            if (!match)
                break;
            _a = __read(match, 4), first = _a[1], von = _a[2], last = _a[3];
            break;
        case 2:
            match = name.match(VON_LAST_FIRST);
            if (!match)
                break;
            _b = __read(match, 4), von = _b[1], last = _b[2], first = _b[3];
            break;
        case 3:
            match = name.match(VON_LAST_JR_FIRST);
            if (!match)
                break;
            _c = __read(match, 5), von = _c[1], last = _c[2], suffix = _c[3], first = _c[4];
            break;
        default:
            literal = name;
    }
    if (literal) {
        return {
            literal: literal,
        };
    }
    return __assign(__assign(__assign({ family: last.trim() }, (first ? { given: first.trim() } : {})), (suffix ? { suffix: suffix.trim() } : {})), (von ? parseNameParticles(von.trim()) : {}));
}
exports.default = default_1;
